//
//
//
//
//
//
//
//
//
//
//
import StarSvg from './StarSvg.vue';
export default {
  props: {
    score: {
      type: String,
      default: '0.0'
    },
    star: {
      type: Array,
      default: function _default() {
        return [0, 0, 5];
      }
    }
  },
  components: {
    StarSvg: StarSvg
  }
};